interface CustomIconGlassdoorChannelProps extends React.SVGProps<SVGSVGElement> {}

export function CustomIconGlassdoorChannel({ width, height }: CustomIconGlassdoorChannelProps) {
  return (
    <svg fill="none" width={width || 48} height={height || 48} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        fill="#0CAA41"
        d="M17.144 20.572H3.43C3.43 22.465 4.963 24 6.856 24h10.286c1.893 0 3.429-1.535 3.429-3.428V6.492c0-.07-.054-.123-.124-.123h-3.18c-.07 0-.123.053-.123.123v14.08zm0-20.572c1.892 0 3.427 1.535 3.427 3.43H6.858v14.078c0 .07-.056.122-.126.122H3.554c-.07 0-.125-.053-.125-.122V3.429C3.43 1.535 4.963 0 6.856 0h10.287z"
      />
    </svg>
  );
}
